function saveToSession (key, value) {
  // Save data to sessionStorage
  try {
    sessionStorage.setItem(key, value)
  } catch (e) {}
}

function getFromSession (key) {
  let sessionData

  try {
    sessionData = sessionStorage.getItem(key)
  } catch (e) {}

  return sessionData
}

function removeFromSession (key) {
  try {
    sessionStorage.removeItem(key)
  } catch (e) {}
}

export {
  saveToSession,
  getFromSession,
  removeFromSession
}
